<template>
  <div class="container">
    <div class="top">
      <h2>资 源 助 手 帮 你 找</h2>
      <p>逛网站时看到感兴趣的文章就能立刻获取！</p>
      <p>馆藏资源随时<span>发现获取</span></p>
      <p>OA资源智能<span>AI帮你找</span></p>
      <p>
        <span> <a>点击浏览器图标,查看安装教程</a></span>
      </p>
      <p><i class="el-icon-d-arrow-right"></i></p>
    </div>
    <div class="ai-bottom">
      <img src="../../assets/images/aibg.png" class="bg" alt="" />
      <div class="list">
        <ul class="flex">
          <li @click="changeTab(1)">
            <a>
              <img src="../../assets/images/browser-firefox.png" />
              <p>FireFox</p>
            </a>
          </li>
          <li @click="changeTab(2)">
            <a>
              <img src="../../assets/images/360.jpg" />
              <p>360</p>
            </a>
          </li>
          <li @click="changeTab(3)">
            <a>
              <img src="../../assets/images/browser-chrome.png" />
              <p>Google</p>
            </a>
          </li>
          <li @click="changeTab(4)">
            <a>
              <img src="../../assets/images/browser-edge.png" />
              <p>Edge</p>
            </a>
          </li>

          <li @click="changeTab(5)">
            <a>
              <img src="../../assets/images/sougou.jpg" />
              <p>sougou</p>
            </a>
          </li>
        </ul>
      </div>
      <div class="w920">
        <h1>安装教程</h1>
        <div v-if="flag == 1">
          <p>这篇教程适用于FireFox</p>
          <p class="title">步骤一、点击资源助手</p>
          <p>
            资源助手安装链接：<a
              target="_blank"
              href="https://addons.mozilla.org/zh-CN/firefox/addon/%E8%B5%84%E6%BA%90%E5%8A%A9%E6%89%8B%E7%AE%80%E6%98%93%E5%AF%BB/?utm_source=addons.mozilla.org&utm_medium=referral&utm_content=search"
              >资源助手</a
            >
          </p>
          <p class="title">步骤二、将资源助手添加到FireFox</p>
          <p>
            通过上面链接跳转到下面的页面，点击添加到FireFox，然后浏览器跳出右上角的提示，点击添加
          </p>
          <img src="../../assets/images/extend/img1-1.png" />
          <p class="title">步骤三、查看扩展</p>
          <p>在右上角三横设置里，点击扩展与主题，可查看安装情况</p>
          <img src="../../assets/images/extend/img1-2.png" />
          <img src="../../assets/images/extend/img1-3.png" />
          <p>注：安装插件前已打开的网页需刷新后才可正常使用插件收藏</p>
          <p class="title">使用说明</p>
          <p>
            主流外文资源网站上检索资源，通过浏览器扩展识别馆藏资源、OA资源、可获取资源，点击资源DOI旁边的全文获取，即可通过登录获取相应全文！
          </p>
          <img src="../../assets/images/extend/img1-4.png" />
        </div>
        <div v-if="flag == 2">
          <p>这篇教程适用于360浏览器</p>
          <p class="title">步骤一、点击资源助手</p>
          <p>
            资源助手安装链接：<a
              target="_blank"
              href="https://ext.se.360.cn/#/extension-detail?id=egeloljeamonaghcdiinimbgecmmbode"
              >资源助手</a
            >
          </p>
          <p class="title">步骤二、打开资源助手，点击立即安装，选择添加</p>
          <img src="../../assets/images/extend/img2-1.png" />
          <img src="../../assets/images/extend/img2-2.png" />
          <p class="title">步骤三、右上角出现AI绿色图标表示安装完成。</p>
          <img src="../../assets/images/extend/img2-3.png" />
          <p class="title">使用说明</p>
          <p>
            安装后效果：例如在百度学术搜索内容后，在资源的详细信息页面会显示扩展按钮如下，在学校IP范围内点击全文获取时显示各个数据库获取方式。在IP范围外点击全文获取时提示登录，用校外统一登录账号密码登录即可。
          </p>
          <img src="../../assets/images/extend/img2-4.png" />
          <img src="../../assets/images/extend/img2-5.png" />
          <img src="../../assets/images/extend/img2-6.png" />
        </div>
        <div v-if="flag == 3">
          <p>这篇教程适用于Chrome浏览器</p>
          <p class="title">
            步骤一、在平台上资源助手菜单里点击资源助手下载
          </p>
          <p>
            资源助手下载链接：<a
              target="_blank"
              href="https://jyx.cxstar.cn/profile/upload/2023/06/18/资源助手扩展插件.zip"
              >资源助手</a
            >
          </p>
          <p>将下载的zip文件解压，找到“资源助手扩展插件”文件夹。</p>
          <img src="../../assets/images/extend/img4-1.png" />
          <p class="title">步骤二、打开“扩展程序”页面</p>
          <p>
            点击Chrome浏览器右上角菜单栏，从"更多工具中打开"扩展程序"，或在网址输入:chrome://extensions/
          </p>
          <img src="../../assets/images/extend/img4-2.png" />
          <p class="title">步骤二、在右上角打开"开发者模式"</p>
          <p>注:Chrome69版本后，需要打开开发者模式才能够进行手动安装</p>

          <img src="../../assets/images/extend/img4-3.png" />
          <p class="title">步骤四、拖拽“资源助手扩展插件”文件进行安装</p>
          <p>将刚才解压缩后的“资源助手扩展插件”文件拖拽至"扩展程序"页面</p>
          <img src="../../assets/images/extend/img4-1.png" />
          <img src="../../assets/images/extend/img4-4.png" />
          <p>安装完成</p>
          <img src="../../assets/images/extend/img4-5.png" />
          <p>注：安装插件前已打开的网页需刷新后才可正常使用插件收藏</p>
        </div>
        <div v-if="flag == 4">
          <p>这篇教程适用于Edge浏览器</p>
          <p class="title">
            步骤一、在平台上资源助手菜单里点击资源助手下载
          </p>
          <p>
            资源助手下载链接：<a
              target="_blank"
              href="https://jyx.cxstar.cn/profile/upload/2023/06/18/资源助手扩展插件.zip"
              >资源助手</a
            >
          </p>
          <p>将下载的zip文件解压，找到“资源助手扩展插件”文件夹。</p>
          <img src="../../assets/images/extend/img4-1.png" />
          <p class="title">
            步骤二、点击浏览器右上角选择扩展，然后点击管理扩展
          </p>
          <img src="../../assets/images/extend/img3-3.png" />
          <p class="title">步骤四：打开开发者模式，选择加载解压缩的扩展</p>
          <img src="../../assets/images/extend/img3-4.png" />
          <p>把解压过的资源助手扩展插件文件夹添加上</p>
          <img src="../../assets/images/extend/img3-5.png" />
          <p>安装成功</p>
          <img src="../../assets/images/extend/img3-6.png" />
        </div>

        <div v-if="flag == 5">
          <p>这篇教程适用于Sougou浏览器</p>
          <p class="title">步骤一、点击下方"资源助手"下载</p>
          <p>
            资源助手下载链接：<a
              target="_blank"
              href="https://jyx.cxstar.cn/profile/upload/2023/06/18/资源助手.zip"
              >资源助手</a
            >
          </p>
          <p>将下载的zip文件解压，找到“资源助手.crx”文件。</p>
          <img src="../../assets/images/extend/img5-1.png" />
          <p class="title">步骤二、打开搜狗浏览器的更多应用</p>
          <p>打开搜狗浏览器，点击右上角更多应用</p>
          <img src="../../assets/images/extend/img5-2.png" />
          <p>打开开发者模式</p>
          <img src="../../assets/images/extend/img5-3.png" />
          <p class="title">步骤三、安装浏览器扩展</p>
          <p>将步骤一打开的“资源助手.crx”文件拖拽到网页内</p>
          <img src="../../assets/images/extend/img5-4.png" />
          <p>点击添加扩展程序</p>
          <img src="../../assets/images/extend/img5-5.png" />
          <p>添加成功</p>
          <img src="../../assets/images/extend/img5-6.png" />
          <p>点击搜狗浏览器更多应用按钮，还可将资源助手移动至前端显示</p>
          <img src="../../assets/images/extend/img5-7.png" />
          点击+号即可
          <img src="../../assets/images/extend/img5-8.png" />
        </div>
        <div v-if="flag == 3 || flag == 4 || flag == 5">
          <p class="title">使用说明</p>
          <p>
            校园IP范围内，主流外文资源网站上检索资源，点击资源DOI旁边的获取按钮，即可获取原文！（馆藏资源+OA资源），如学校配置单篇采选与文献传递，也可对接相应资源。
          </p>
          <p>在校园IP范围外，也可获取OA资源。</p>
          <p>点击全文获取按钮以后</p>
          <img src="../../assets/images/extend/imgs-1.png" />
          <p>提示登录，输入账号密码，即可跳转获取。</p>
          <img src="../../assets/images/extend/imgs-2.png" />
          <img src="../../assets/images/extend/imgs-3.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
export default {
  name: "AiHelp",
  data() {
    return {
      flag: 1,
    };
  },
  mounted() {},

  methods: {
    changeTab(index) {
      this.flag = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: #fff;
  .top {
    text-align: center;
    h2 {
      font-size: 50px;
      padding-top: 40px;
    }
    p {
      font-weight: bold;
      span {
        color: #2d8cf0;
      }
      &:nth-of-type(1) {
        margin: 50px 0;
        margin-top: 40px;
      }
      &:nth-of-type(2) {
        margin-bottom: 20px;
      }
      &:nth-of-type(4) {
        font-weight: normal;
        margin-top: 70px;
        font-size: 14px;
      }
      i {
        transform: rotate(90deg);
        color: #999;
        font-size: 22px;
        margin-top: 5px;
        margin-bottom: 180px;
      }
    }
  }
  .ai-bottom {
    background: #f3f4f6;
    position: relative;
    .bg {
      position: absolute;
      top: -50px;
      left: 0;
      width: 100%;
    }
    .list {
      position: absolute;
      width: 800px;
      top: -120px;
      left: 50%;
      margin-left: -400px;

      ul {
        justify-content: space-between;
        li {
          background: #fff;
          width: 100px;
          border-radius: 5px;
          border: 1px solid #f3f4f6;
          box-shadow: 0px 5px 10px #999;
          color: #ccc;
          padding: 20px 0;
          cursor: pointer;
          text-align: center;
          font-size: 12px;
          img {
            width: 40px;
            height: 40px;
          }
          p {
            margin-top: 10px;
          }
        }
      }
    }
    .w920 {
      width: 920px;
      background: #fff;
      margin: 0 auto;
      padding: 30px;
      padding-top: 40px;
      p {
        color: #666;
        margin: 15px 0;
      }
      .title {
        color: #333;
        font-size: 18px;
        font-weight: bold;
      }
      img {
        max-width: 100%;
      }
      a {
        color: #2d8cf0;
        text-decoration: underline;
      }
    }
  }
}
</style>
